export default function CtaSection() {
  return (
    <section className="relative w-full py-24 md:py-32 px-6 md:px-10 overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage:
            "url(https://readdy.ai/api/search-image?query=Warm%20sunlit%20fashion%20display%20with%20folded%20linen%20shirts%20straw%20hat%20canvas%20tote%20bag%20and%20espadrilles%20on%20weathered%20wooden%20table%20outdoor%20terrace%20setting%20with%20olive%20trees%20in%20background%20golden%20hour%20lighting%20Mediterranean%20vibe%20editorial%20photography%20high%20detail%20relaxed%20luxury%20aesthetic&width=1600&height=700&seq=cta-lifestyle-summer-2026&orientation=landscape)",
        }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/25 to-black/35"></div>

      <div className="relative z-10 max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row items-start lg:items-end gap-10">
          <div className="flex-1">
            <h2 className="font-heading text-3xl md:text-5xl text-background-50 leading-tight mb-4 max-w-lg">
              gtb<span className="text-primary-400">uy sheet</span> — your sourcing partner
            </h2>
          </div>

          <div className="flex-1 flex flex-col items-start lg:items-end gap-4">
            <p className="text-background-50/75 text-sm md:text-base max-w-sm lg:text-right leading-relaxed">
              Ready to level up your ecommerce sourcing? Head over to KA Spreadsheet
              and discover a better way to manage your product inventory.
            </p>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="px-6 py-3 rounded-full bg-background-50 text-foreground-950 font-medium text-sm hover:bg-background-100 transition-colors cursor-pointer whitespace-nowrap inline-flex items-center gap-2"
            >
              Buy It Now
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}